export const indexCopy = {
  index_headline: "<bold>JavaScript dengan Tipe dalam skala apapun.</bold>",
  index_byline: "TypeScript memperluas JavaScript dengan menambahkan tipe.",
  index_summary:
    "Dengan memahami JavaScript, TypeScript menghemat waktu Anda dalam menangkap galat dan memberikan perbaikan sebelum Anda menjalankan kode.",
  index_locations:
    "Browser apa pun, OS apa pun, di mana pun JavaScript berjalan. Sepenuhnya Sumber Terbuka.",

  index_cta_play: "Coba di peramban",
  index_cta_install: "Pasang di lokal",

  index_what_is: "Apa itu TypeScript?",

  index_what_is_js: "JavaScript dan Lainnya",
  index_what_is_js_copy: `
<p>TypeScript adalah bahasa sumber terbuka yang dibangun di atas JavaScript, salah satu alat yang paling banyak digunakan di dunia, dengan menambahkan definisi tipe statis.</p>

<p>Tipe menyediakan cara untuk mendeskripsikan bentuk objek, memberikan dokumentasi yang lebih baik, dan memungkinkan TypeScript untuk memvalidasi bahwa kode Anda berfungsi dengan benar.</p>

<p>Penulisan tipe dapat bersifat opsional di TypeScript, karena inferensi tipe memungkinkan Anda mendapatkan banyak daya tanpa menulis kode tambahan.</p>`,

  index_trust: "Hasil yang Dapat Anda Percayai",
  index_trust_copy_a: `Semua kode JavaScript yang valid juga merupakan kode TypeScript. Anda mungkin mendapati galat pemeriksaan tipe, tetapi itu tidak akan menghentikan Anda untuk menjalankan JavaScript yang dihasilkan meskipun Anda dapat melakukan perilaku yang lebih ketat. Itu berarti Anda tetap memegang kendali.`,
  index_trust_copy_b: `Kode TypeScript diubah menjadi kode JavaScript melalui penyusun TypeScript atau <babel>Babel</babel>. JavaScript ini bersih, kode sederhana yang berjalan di mana saja JavaScript dijalankan: Di peramban, di Node.JS atau di aplikasi Anda.`,
  index_standards: "Berkembang dengan Standar",
  index_standards_copy: `
  <p>Tim TypeScript berkontribusi pada komite TC39 yang membantu memandu evolusi bahasa JavaScript.</p>

  <p>Ketika fitur baru telah mencapai tahap 3, maka mereka siap untuk dimasukkan ke dalam TypeScript.</p>

  <p>Misalnya, tim TypeScript memperjuangkan proposal seperti Optional Chaining, Nullish coalescing Operator, Throw Expressions, dan Indeks Pencocokan RegExp.</p>`,

  index_gradual: "Adopsi Bertahap",
  index_gradual_copy: `
<p>Mengadopsi TypeScript bukanlah pilihan biner, Anda dapat mulai dengan membuat anotasi JavaScript yang ada dengan JSDoc, kemudian mengganti beberapa file untuk diperiksa oleh TypeScript dan dari waktu ke waktu mempersiapkan basis kode Anda untuk dikonversi sepenuhnya.</p>

<p>Inferensi tipe TypeScript berarti Anda tidak perlu membuat anotasi kode sampai Anda menginginkan keamanan lebih.</p>`,

  index_dts: "Tipe Di Setiap Meja",
  index_dts_copy: `
<p>Sebagian besar JavaScript di dunia tidak memiliki tipe, dan inferensi hanya dapat digunakan sejauh ini. To address this, tim TypeScript membantu memelihara <dt>Definitely Typed</dt> - sebuah proyek komunitas untuk menyediakan tipe dan dokumentasi sebaris ke JavaScript yang ada.</p>

<p>Proyek ini memungkinkan komunitas untuk mempertahankan definisi tipe untuk pustaka JavaScript tanpa memberi tekanan ekstra pada pemeliharanya.</p>`,

  index_tools: "Perkakas yang Bagus",
  index_tools_copy: `
  <p>Dengan menangani banyak integrasi editor di dalam TypeScript, Anda bisa mendapatkan pengalaman yang konsisten bekerja di banyak editor.</p>

  <p>Ini memungkinkan Anda beralih dengan mudah di antara editor seperti <vs>Visual Studio</vs>, <vsc>Visual Studio Code</vsc>, <nova>Nova</nova>, <atom>Atom</atom>, <subl>Sublime Text</subl>, <emacs>Emacs</emacs>, <vim>Vim</vim>, <webs>WebStorm</webs> dan <eclipse>Eclipse</eclipse>.</p>

  <p>Integrasi editor TypeScript mendukung JavaScript, jadi kemungkinan besar Anda sebenarnya sudah menggunakan TypeScript.</p>
  `,

  index_started_title: "Memulai",
  index_started_handbook: "Buku saku",
  index_started_handbook_blurb: "Pelajari bahasanya",
  index_started_docs: "Mulai projek",
  index_started_docs_blurb: "Temukan alat bootstrap",
  index_started_tooling: "Alat",
  index_started_tooling_blurb: "Menyelami TypeScript lebih dalam",
  index_started_community: "Komunitas",
  index_started_community_blurb: "Tetap terbaru",
  index_install: "Pasang TypeScript",
  index_install_ref: `
  <p>Anda dapat memasang TypeScript melalui npm<install>
  <p>kemudian jalankan penyusun melalui <code>tsc</code><pre>npx tsc</pre>
  <p>Pelajari lebih lanjut tentang cara menambahkan TypeScript ke aplikasi Anda di <download>halaman pemasangan</download>
  `,
  index_releases: "Rilis Tiga Bulanan",
  index_releases_pt1: "Rilis kami berikutnya adalah ",
  index_releases_pt2: ", yang direncanakan untuk ",
  index_releases_released: "Rilis",
  index_releases_beta: "Beta",
  index_releases_rc: "RC",

  index_migration_title: "Cerita Migrasi",
  index_migration_oss: "Sumber Terbuka dengan TypeScript",
  index_videos_title: "Tonton TypeScript in Action",
}
